import L from 'leaflet';
import '../index.scss';
export const mapUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const getIconMarker = (status) => {

  let iconPath = 'logo.png';

  switch (status) {
    case 1:
      iconPath = 'blue-marker.png';
      break;
    case 2:
      iconPath = 'green-marker.png';
      break;
    case 3:
      iconPath = 'red-marker.png';
      break;
    case 4:
      iconPath = 'marker.png';
      break;
    default:
      iconPath = 'marker.png';
      break;
  }

  return new L.Icon({
    iconUrl: require(`../assets/${iconPath}`),
    iconRetinaUrl: require(`../assets/${iconPath}`),
    iconAnchor: null,
    popupAnchor: [0, -15],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(48, 48)
  });

}


export const simpleMarker = new L.Icon({
  iconUrl: require('../assets/marker.png'),
  iconRetinaUrl: require('../assets/marker.png'),
  iconAnchor: null,
  popupAnchor: [-3, -56],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(60, 60)
});